
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 92 92","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.9548 68.3203C38.2819 79.391 57.2495 78.3724 68.3202 66.0454C79.3908 53.7183 78.3723 34.7507 66.0452 23.68C53.7182 12.6093 34.7505 13.6278 23.6799 25.9549C12.6092 38.282 13.6277 57.2496 25.9548 68.3203Z","stroke":"#0275D8","stroke-width":"4","stroke-dasharray":"141.37 49.12"}})])
          )
        }
      }
    